import React, {useEffect, useState} from 'react'
import ApplicationsData from "../../datas/Applications.json"
import RippleButton from '../../../../components/Buttons/RippleButton'
import { BiFilter } from 'react-icons/bi'
import ico from "../../../assets/searchIcon/search.svg"
import axios from "axios"
import { API_END_POINT, END_POINT } from '../../../../utils/constant'
import dayjs from 'dayjs'; // For date manipulation
import { useSelector } from 'react-redux'
import { formatInDate } from '../../../../components/DateTimeConverter/DateTimeConverter'
import ImageWithFallback from '../../../components/ImageWithFallback'

const Applications = () => {
  const [application, setApplication] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('Tous');
  const [selectedPeriod, setSelectedPeriod] = useState('Tous');
  const {user} = useSelector(store=>store.user)

  useEffect(() => {
    // Fetch data from JSON or API
    axios.get(API_END_POINT+"/application/"+user?.id+"/all")
      .then(response => {
        console.log(response.data)
        setApplication(response.data);
        setFilteredTasks(response.data); // Initial load
      })
      .catch(error => {
        console.error("Error fetching tasks data:", error);
      });
    // setApplication(ApplicationsData);
    // setFilteredTasks(ApplicationsData);
  }, []);

  // Filtering function
  useEffect(() => {
    let filtered = application;

    // Filter by keyword
    if (searchKeyword) {
      filtered = filtered.filter(task =>
        task?.offer?.job_title?.toLowerCase().includes(searchKeyword.toLowerCase())
      );
    }

    // Filter by status
    if (selectedStatus !== 'Tous') {
      filtered = filtered.filter(task => task.status === selectedStatus);
    }

    // Filter by period
    if (selectedPeriod !== 'Tous') {
      const now = dayjs();
      filtered = filtered.filter(task => {
        const taskDate = dayjs(task.dueDate, 'DD-MM-YYYY'); // Adjust date format
        if (selectedPeriod === 'Ce mois') {
          return taskDate.isSame(now, 'month');
        } else if (selectedPeriod === '3 derniers mois') {
          return taskDate.isAfter(now.subtract(3, 'month'));
        } else if (selectedPeriod === 'Cette année') {
          return taskDate.isSame(now, 'year');
        }
        return true;
      });
    }

    setFilteredTasks(filtered);
  }, [searchKeyword, selectedStatus, selectedPeriod, application]);

  return (
    <div className='min-h-full w-full pr-6  xl:pr-40 pl-6 text-primary-black py-10'>
      <h1 className='font-semibold mb-6 text-start'>Candidature</h1>

      {/* Status Filters */}
      <div className="flex sticky top-0 border-b w-full my-4 text-sm bg-white pt-2">
        {['Tous', 'En attente', 'Entretien', 'Réfusé', 'Embauché'].map(status => (
          <button
            key={status}
            className={`px-6 py-2 font-bold ${selectedStatus === status ? 'border-b-2 border-black' : 'hover:text-primary-black'}`}
            onClick={() => setSelectedStatus(status)}
          >
            {status}
          </button>
        ))}
      </div>

      <div className="flex justify-between items-center">
        <h4 className='font-semibold whitespace-nowrap'>Historique des candidatures</h4>

        <div className="flex gap-2">
          {/* Search Bar */}
          <div className="relative flex items-center h-10 rounded-lg overflow-hidden border">
            <div className="grid place-items-center h-full w-12 text-gray-300">
              <img src={ico} alt="searchbtn" />
            </div>
            <input
              className="peer h-full w-full outline-none text-sm text-gray-700 pr-2"
              type="text"
              id="search"
              placeholder="Mot clé..."
              value={searchKeyword}
              onChange={e => setSearchKeyword(e.target.value)}
            />
          </div>

          {/* Period Filter */}
          <select
            className="px-4 py-2 font-medium border text-sm rounded-md"
            value={selectedPeriod}
            onChange={(e) => setSelectedPeriod(e.target.value)}
          >
            {['Tous', 'Ce mois', '3 derniers mois', 'Cette année'].map(period => (
              <option key={period} value={period}>{period}</option>
            ))}
          </select>

          {/* Filter button */}
          <button className="px-4 py-2 font-medium border text-[#24292F] hover:bg-primary-black hover:text-white rounded-md focus:outline-none text-sm flex gap-1 items-center">
            <BiFilter className='w-5 h-5' />
            Filtrer
          </button>
        </div>
      </div>

      <div className="overflow-auto py-4 w-full">
        <div className="">
          <table className="w-full">
            <thead className='text-sm'>
              <tr className="text-left bg-neutral-100 py-4 rounded-sm">
                <th className="pl-5 bg-neutral-100 py-4 rounded-sm">Title</th>
                <th className="pl-5 bg-neutral-100 py-4 rounded-sm">Date de candidature</th>
                <th className="pl-5 bg-neutral-100 py-4 rounded-sm">Etat</th>
                <th className="pl-5 bg-neutral-100 py-4 rounded-sm">Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredTasks?.map(task => (
                <tr key={task.id} className="border-b border-gray-100 rounded">
                  <td className="pl-5 py-2 whitespace-nowrap">
                    <div className="flex items-center gap-2">
                      <div className="min-w-14 h-14 overflow-hidden bg-neutral-50 border border-slate-100 rounded-md flex items-center justify-center">
                      <ImageWithFallback src={END_POINT+"/storage"+ task?.offer?.image} className=" object-cover w-[62px] h-full bg-cover bg-center"/>
                      </div>
                      <div className="flex flex-col justify-between">
                        <p className="text-base font-medium mr-2">{task?.offer?.job_title}</p>
                        <div className="flex gap-2 text-xs">{task?.offer?.address}</div>
                      </div>
                    </div>
                  </td>
                  <td className="pl-5">
                    <p className="text-sm leading-none text-start">{formatInDate(task?.created_at)}</p>
                  </td>
                  <td className="pl-5 justify-start">
                    <button className="py-3 px-3 text-sm text-[#0BA02C] flex items-center gap-1">
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-4 w-4 text-[#0BA02C]" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M5 12l5 5l10 -10"></path>
                      </svg>
                      {task.status}
                    </button>
                  </td>
                  <td className="pl-5 whitespace-nowrap">
                    <RippleButton path={"/offre/" + task?.offer?.id}>Voir détail</RippleButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Applications